import _ from 'lodash';
import { getAuthNetworksConfig } from 'helpers/ConfigHelper';

export const defaultChannelId = 'fbc-fox';

export const getChannelId = ({ network, authorizingNetwork }) => {
  const networks = getAuthNetworksConfig();
  const resourceId = _.get(networks, `${network}.resourceId`);
  return resourceId || defaultChannelId;
};
